export default __webpack_public_path__ + "static/media/bascback-banner-1.e2ff5482.svg";